import { useNavigate } from 'react-router-dom';

import { EmphasizeCircleIcon } from '@_shared/icons';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { InformationPopup } from '@_shared/ui/Popup';

import { useFolderAction } from '../../hooks';

interface IProps {
	folderId: string;
	isFolderListPage: boolean;
}

export function FolderDeletePopup({ folderId, isFolderListPage }: IProps) {
	const navigate = useNavigate();
	const { clearLayers, popLayer } = useUILayerStore();
	const { deleteFolder } = useFolderAction();

	function handleDeleteFolder() {
		deleteFolder(folderId)
			.then(() => {
				clearLayers();
				if (!isFolderListPage) {
					navigate(-1);
				}
			})
			.catch(() => {
				clearLayers();
			});
	}

	return (
		<InformationPopup.Container closePopup={popLayer}>
			<EmphasizeCircleIcon />
			<InformationPopup.TextContainer>
				<InformationPopup.Title>
					이 폴더를
					<br />
					삭제하시겠어요?
				</InformationPopup.Title>
				<InformationPopup.Warning>
					폴더를 삭제하면, 안에 담긴 콘텐츠도 함께 삭제되고 다시 복구할 수 없어요.
				</InformationPopup.Warning>
			</InformationPopup.TextContainer>
			<InformationPopup.ButtonContainer>
				<InformationPopup.Button type="deny" onClick={popLayer}>
					아니요
				</InformationPopup.Button>
				<InformationPopup.Button type="confirm" onClick={handleDeleteFolder}>
					네, 삭제할게요
				</InformationPopup.Button>
			</InformationPopup.ButtonContainer>
		</InformationPopup.Container>
	);
}
